var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.comment)?_c('v-card',{staticClass:"my-4 pa-3 rounded-0",staticStyle:{"font-size":"12.5px"},attrs:{"color":"rgb(255, 209, 189)"}},[_c('b',[_vm._v(_vm._s(_vm.$t('partner.job.service_manager_comment')))]),_c('br'),_vm._v(" "+_vm._s(_vm.comment)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }